import React, { useEffect, useState } from "react";
import "../css/entryPoint.css";
import { getSizeAndPath } from "../js/toolsOptions";
import Menus from "./Menus";
import History from "../js/history";
import Spray from "../js/spray";
import AddAsset from "../js/addAsset";
import Draw from "../js/draw";
import Utility from "../js/utility";
import checkers from "../images/checkers.png";

// class made to share stuff between components;
export class Common {
  static newImage = new Image();
  static rotationAngle;
  static tool = "pencil";
  static width = getSizeAndPath("pencil")[0];
  static defaultColor = "#000000";
  static color = Common.defaultColor;
  static selectedTool = "pencil";
  static selected_tool_id = "2";
  static previous_selected_tool_id = "2";
  static selectedSize = 0;
  static selectedColor;
  static selectedGlitter;
  static glitter = false;
  static glitterID;
  static bucket;
  static sprayOpacity = 0.5;
  static bgColor = "#ffffff";
  static erasor_color = "#D0D0D0";
  static tape_pattern = checkers;
  static mouse_position = { x: 0, y: 0 };
  static mobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    (/Macintosh/.test(navigator.userAgent) && "ontouchend" in document);
  static main_canvas;
  static main_ctx;
  static spray_canvas;
  static spray_ctx;
  static background_ID = 0;
  static bg_canvas;
  static bg_ctx;
  static canvas_width;
  static canvas_height;
  static background;
  static tape;
  static shadow_thickness = 5;
  static font_size;
  static history_canvas;
  static history_ctx;
  // for events on desktop and mobile;
  static pointerdown;
  static pointermove;
  static pointerup;
}

export default function EntryPoint() {
  // Sets "font-size" of "<html>" to the width of it, in pixels. All other elements get their dimensions
  //relative to this font-size, in rems;
  function mobileDimension() {
    document.documentElement.style.fontSize =
      document.documentElement.clientHeight + "px";
  }

  // If mobile, resize elements;
  if (window.innerHeight < 770) {
    mobileDimension();
  }

  const [dimensions, setDimensions] = useState(false);

  useEffect(() => {
    let iOS = /iPhone|iPod|iPad/.test(navigator.platform);
    
    if (iOS) {
      // if (!dimensions) {
      //   setTimeout(() => {
      //     let height = window.innerHeight;
      //     document.documentElement.style.height = height + "px";
      //     console.log(window.innerHeight);
      //     setDimensions(true);
      //   }, 250);
      // }
      // let vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty("--vh", `${vh}px`);
      // window.addEventListener("resize", () => {
      //   // Update the element's size
      //   let vh = window.innerHeight * 0.01;
      //   document.documentElement.style.setProperty("--vh", `${vh}px`);
      // });
    }

    let canvasContainer = document.querySelector(".canvasContainer");
    canvasContainer.style.height = window.innerHeight + "px";

    // if (iOS) {
    //   canvasContainer.style.height = window.innerHeight + "px";
    // }

    // console.log($.documentHeight());
    // console.log($.windowHeight());

    // console.log($(window).height());

    Common.main_canvas = document.querySelector(".main_canvas");
    Common.main_ctx = Common.main_canvas.getContext("2d", { antialias: false });
    Common.spray_canvas = document.querySelector(".spray_canvas");
    Common.spray_ctx = Common.spray_canvas.getContext("2d");
    Common.bg_canvas = document.querySelector(".bg_canvas");
    Common.bg_ctx = Common.bg_canvas.getContext("2d");
    let main_canvas_Width = canvasContainer.clientWidth;
    let main_canvas_Height = canvasContainer.clientHeight;
    Common.canvas_width = main_canvas_Width;
    Common.canvas_height = main_canvas_Height;

    // console.log(window.innerHeight);
    // console.log(Common.canvas_height);

    Common.main_canvas.width = main_canvas_Width;
    Common.main_canvas.height = main_canvas_Height;

    // Utility.scaleCanvas(
    //   Common.main_canvas,
    //   Common.main_ctx,
    //   Common.canvas_width,
    //   Common.canvas_height
    // );
    // ----------------------

    // let dpi = window.devicePixelRatio;
    // function fix_dpi() {
    //   //create a style object that returns width and height
    //   let style = {
    //     height() {
    //       return +getComputedStyle(Common.main_canvas)
    //         .getPropertyValue("height")
    //         .slice(0, -2);
    //     },
    //     width() {
    //       return +getComputedStyle(Common.main_canvas)
    //         .getPropertyValue("width")
    //         .slice(0, -2);
    //     },
    //   };
    //   //set the correct attributes for a crystal clear image!
    //   Common.main_canvas.setAttribute("width", style.width() * dpi);
    //   Common.main_canvas.setAttribute("height", style.height() * dpi);
    // }
    // Common.fix_dpi = fix_dpi;

    // ---------------------- history canvas
    let history_canvas = document.createElement("canvas");
    let history_ctx = history_canvas.getContext("2d");

    history_canvas.width = main_canvas_Width;
    history_canvas.height = main_canvas_Height;
    Common.history_canvas = history_canvas;
    Common.history_ctx = history_ctx;
    // ----------------------

    let canvas = document.querySelector(".main_canvas");
    let ctx = canvas.getContext("2d");
    let rightMenu = document.querySelector(".rightMenuBorder");

    let history = new History();

    Draw.history = history;

    Common.bg_canvas.width = main_canvas_Width;
    Common.bg_canvas.height = main_canvas_Height;

    canvas.width = main_canvas_Width;
    canvas.height = main_canvas_Height;
    ctx.imageSmoothingEnabled = true;

    // add blank canvas to history as first intro;
    history.addToHistoryTest();
    history.addToHistoryTest();
    history.backgrounds[0] = Common.history_canvas.toDataURL();

    // ------------------- undo/clean listeners
    history.addListeners();

    if (Common.mobile) {
      document.addEventListener(
        "touchmove",
        function (ev) {
          ev.preventDefault();
        },
        { passive: false }
      );
    }

    Common.pointerdown = Common.mobile ? "touchstart" : "mousedown";
    Common.pointermove = Common.mobile ? "touchmove" : "mousemove";
    Common.pointerup = Common.mobile ? "touchend" : "mouseup";

    canvas.addEventListener(Common.pointerdown, drawingType);
    canvas.addEventListener(Common.pointerdown, Draw.draw);
    canvas.addEventListener(Common.pointerup, history.addToHistory);

    function drawingType(ev) {
      Utility.setPosition(ev);

      if (!Common.glitter) {
        canvas.removeEventListener(Common.pointerdown, Draw.draw_glitter);
        canvas.addEventListener(Common.pointerdown, Draw.draw);
      } else {
        canvas.removeEventListener(Common.pointerdown, Draw.draw);
        canvas.addEventListener(Common.pointerdown, Draw.draw_glitter);
      }
    }

    // ----------------------- spray

    let spray_canvas = document.querySelector(".spray_canvas");

    let spray = new Spray(history);

    spray_canvas.addEventListener(Common.pointerdown, spray.drawSpray);
    spray_canvas.addEventListener(Common.pointermove, spray.drawSpray);
    spray_canvas.addEventListener(Common.pointerup, spray.drawSprayEnd);
    spray_canvas.addEventListener(Common.pointerdown, Utility.setPosition);

    // ----------------------- add/cancel listeners for uploaded image

    let asset = new AddAsset();

    asset.photo(Draw.draw_image);

    // ----------------------- stickers

    asset.sticker();

    // ----------------------- draw background

    rightMenu.addEventListener("click", (ev) => {
      let target = ev.target;
      if (target.nodeName !== "IMG" || rightMenu.dataset.name === "tapes")
        return;

      // if same background is selected don't do anything;
      if (ev.target.parentNode.classList.contains("background_selected"))
        return;

      Draw.draw_background(target.src);
    });

    // get font size to reduce sizes of tools;
    let font_size = parseFloat(document.documentElement.style.fontSize);
    if (font_size) {
      Common.font_size = font_size;
    }

    return () => {
      canvas.removeEventListener(Common.pointerdown, Utility.setPosition);
      canvas.removeEventListener("pointerenter", Utility.setPosition);

      spray_canvas.removeEventListener(Common.pointerdown, spray.drawSpray);
      spray_canvas.removeEventListener(Common.pointermove, spray.drawSpray);
      spray_canvas.removeEventListener(Common.pointerup, spray.drawSprayEnd);
      spray_canvas.removeEventListener(Common.pointerdown, Utility.setPosition);
      spray_canvas.removeEventListener(Common.pointerup, Utility.setPosition);
    };
  }, [dimensions]);

  return (
    <>
      <div className="canvasContainer">
        <canvas className="main_canvas"></canvas>
        <canvas className="spray_canvas"></canvas>
        <canvas className="bg_canvas"></canvas>
        <div className="tape_wrapper">
          <canvas className="tape_canvas"></canvas>
        </div>
        <Menus />
      </div>
    </>
  );
}
